import { useSearchParams } from "react-router-dom";
import ContactSection from "../components/sections/ContactSection";
import "./ContactPage.css";
import HERO_BG from "../components/ui/bg_image.svg";


export default function ContactPage() {

    const [params] = useSearchParams();
    const interest = params.get("interest") || "";

    return (
        <main data-testid="contact-page" className="contact-page-wrapper">
            <section className="contact-page-header position-relative overflow-hidden">
                <div
                    className="hero-bg-image"
                    // style={{ backgroundImage: `url(${HERO_BG})` }}
                    aria-hidden
                />
                <div
                    className="hero-overlay"
                    aria-hidden
                />
                <div className="grain position-absolute top-0 bottom-0 start-0 end-0 pe-none" aria-hidden />

                <div className="container-db position-relative">
                    <div className="font-mono-tech section-eyebrow fade-in-up fs-5">
                        ⟶ Let's connect

                    </div>
                    <h1
                        data-testid="font-heading hero-title"
                        className="font-heading hero-title m-0"
                    >
                        get in touch

                        {/* <br />
                        <span className="text-primary-custom">Touch</span> */}
                    </h1>
                </div>
            </section>
            <ContactSection defaultInterest={interest} />
        </main>
    );
}
